import React from 'react';

interface IProps {
    error: string;
}

function AuthFormItemWrapper({ children, error }: React.PropsWithChildren<IProps>) {
    return (
        <div className="form-group">
            <div className={`input-group${error.length > 0 ? ' is-invalid' : ''}`}>
                {children}
            </div>
            {error && error.length > 0 && (
                <div className="invalid-feedback">
                    <b>{error}</b>
                </div>
            )}
        </div>
    );
}

export default AuthFormItemWrapper;
